import React from 'react';
import { css } from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import {
  applyStyles,
  convertDoubleWidthNumber,
  convertDoubleWidthAlpha,
  convertDoubleWidthSpace
} from 'util/helpers';
import i18n from 'i18n';
import BlockHeader from 'components/common/BlockHeader';
import TextField from 'components/common/TextField';
import HiddenField from 'components/common/HiddenField';
import ExpiresField from './ExpiresField';
import Image from 'components/common/Image';
import imgCardsPC1x from 'assets/images/PC/@1x/img_cards.png';
import imgCardsPC2x from 'assets/images/PC/@2x/img_cards.png';
import imgCardsSP2x from 'assets/images/SP/@2x/img_cards.png';
import imgCardsSP3x from 'assets/images/SP/@3x/img_cards.png';

import {
  required,
  mustBeNumber,
  holdernamePattern,
  minLength,
  composeValidators
} from 'validation/validators';

const handleBlurNumbers = (change, key, value) => {
  const replaced = convertDoubleWidthNumber(value);

  change(key, replaced);
};

const handleBlurHolderName = (change, value) => {
  const replacedAlpha = convertDoubleWidthAlpha(value);
  const replaced = convertDoubleWidthSpace(replacedAlpha);

  change('payment.holdername', replaced);
};

const Credit = ({ className, change }) => (
  <div className={className}>
    <div className="card-kind">
      <div className="card-kind-label">
        {i18n.t('orderAggregators:payment:payment.card.kind')}
      </div>
      <Image
        pc1x={imgCardsPC1x}
        pc2x={imgCardsPC2x}
        sp2x={imgCardsSP2x}
        sp3x={imgCardsSP3x}
        alt="img_card1"
      />
    </div>

    <div className="pay-count">
      <div className="pay-count-label">
        {i18n.t('orderAggregators:payment:payment.card.count')}
      </div>
      <div>{i18n.t('orderAggregators:payment:payment.card.countNote')}</div>
    </div>

    <HiddenField name="customer.email" />

    <TextField
      type="tel"
      name="payment.cardno"
      validate={value => composeValidators(required, mustBeNumber)(value)}
      label={i18n.t('orderAggregators:payment:payment.card.cardno')}
      maxLength={16}
      placeholder={i18n.t(
        'orderAggregators:payment:payment.card.cardnoPlaceholder'
      )}
      required={true}
      onBlur={value => handleBlurNumbers(change, 'payment.cardno', value)}
      autoComplete="cc-number"
    />

    <ExpiresField required={true} />

    <TextField
      name="payment.holdername"
      validate={value => composeValidators(required, holdernamePattern)(value)}
      label={i18n.t('orderAggregators:payment:payment.card.holdername')}
      maxLength={50}
      placeholder={i18n.t(
        'orderAggregators:payment:payment.card.holdernamePlaceholder'
      )}
      onBlur={value => handleBlurHolderName(change, value)}
      required={true}
      notes={[i18n.t('orderAggregators:payment:payment.card.holdernameNote')]}
      autoComplete="cc-name"
    />

    <TextField
      type="tel"
      name="payment.securitycode"
      validate={value =>
        composeValidators(required, mustBeNumber, minLength(3))(value)
      }
      label={i18n.t('orderAggregators:payment:payment.card.securitycode')}
      maxLength={4}
      placeholder={i18n.t(
        'orderAggregators:payment:payment.card.securitycodePlaceholder'
      )}
      required={true}
      notes={[i18n.t('orderAggregators:payment:payment.card.securitycodeNote')]}
      onBlur={value => handleBlurNumbers(change, 'payment.securitycode', value)}
      autoComplete="cc-csc"
    />
  </div>
);

const commonStyle = css`
  .pay-count {
    ${FontStyles.text8};
  }

  .card-kind-label,
  .pay-count-label {
    ${FontStyles.text5};
    margin-top: 40px;
    margin-bottom: 16px;
  }

  input[name='payment.holdername'] {
    text-transform: uppercase;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  .card-kind {
    img:first-of-type {
      margin-right: 32px;
    }
  }
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${BlockHeader} {
    margin-right: 16px;
    margin-left: 16px;
  }

  .card-kind {
    padding: 0 16px;
    img:first-of-type {
      margin-right: 16px;
    }
  }

  .pay-count {
    padding: 0 16px;
  }
`;

export default applyStyles(Credit)(commonStyle, pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/Payment/components/Credit.js